import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.loadingVoucherBatches, action) => {
  switch (action.type) {
    case types.BEGIN_LOAD_VOUCHER_BATCHES:
      return true;
    case types.FINISH_LOAD_VOUCHER_BATCHES:
      return false;

    default:
      return state;
  }
};
